import React, {forwardRef} from 'react';
import MaterialTextField from '@material-ui/core/TextField';

function TextField(props, ref) {
  const dataTestId = props['data-testid'];
  return (
    <MaterialTextField
      {...props}
      ref={ref}
      FormHelperTextProps={{
        ...props.FormHelperTextProps,
        'data-testid': `${dataTestId}--helper`,
      }}/>
  );
}

export default forwardRef(TextField);
